import { styled } from 'styles/stitches.config'
import { rem } from 'polished'

export const Left = styled('article', {
  flex: 1,
  marginBottom: 50,

  '@lg': {
    marginBottom: 0,
  },
})

export const Content = styled('div', {
  marginBottom: 48,

  '& p': {
    marginBottom: 22,

    fontFamily: '$raleway',
    fontSize: rem(13),
    lineHeight: '200%',
    color: '$grey600',
  },

  '& h3': {
    marginBottom: 22,
  },

  '& img': {
    margin: '0 auto',
    border: '4px solid $white ',
    boxShadow: '0 0 8px rgba(0, 0, 0, 0.6)',
    cursor: 'pointer',
  },

  '& ul': {
    marginBottom: 22,
    paddingLeft: 13,

    fontFamily: '$raleway',
    fontSize: rem(13),
    lineHeight: '200%',
    color: '$grey600',

    '& li': {},
  },

  '& a': {
    color: '$black500',
    textDecoration: 'underline',
  },

  '& .wp-video': {
    width: '100% !important',
    marginBottom: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '& figure': {
    marginBottom: 22,
  },

  '& video': {
    display: 'flex',
    margin:"0 auto"
  },
})

export const Right = styled('aside', {
  flex: 1,

  border: 'solid 1px',
  borderColor: '$emerald500',
  borderRadius: 8,
  padding: '40px 24px',

  '& h4': {
    fontSize: '28px !important',
    marginBottom: 48,
  },

  '@lg': {
    marginLeft: 34,
    maxWidth: 400,
  },

  '@xxl': {
    marginLeft: 94,
  },
})

export const OthersTitle = styled('h5', {
  fontWeight: 'bold',
  fontSize: rem(15),
  color: '$grey900',
})

export const OthersBottom = styled('div', {
  marginTop: 8,
  paddingBottom: 8,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  borderBottom: 'solid 1px',
  borderColor: '$grey300',
})

export const Others = styled('div', {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',

  '&:not(:last-of-type)': {
    marginBottom: 40,
  },

  '&:hover': {
    [`& ${OthersTitle}`]: {
      color: '$emerald500',
    },
    [`& ${OthersBottom}`]: {
      borderColor: '$emerald500',
    },
  },
})

export const OthersFigure = styled('figure', {
  width: 86,
  height: 86,
  marginRight: 16,

  borderRadius: 4,
  background: '#ccc',
  cursor: 'pointer',
})

export const OthersFigureImage = styled('img', {
  width: '100%',
  height: '100%',
  marginRight: 16,

  borderRadius: 4,
  objectFit: 'cover',
})

export const OthersRight = styled('div', {
  flex: 1,
})

export const OthersText = styled('time', {
  color: '$grey600',
  fontFamily: '$manrope',
  fontSize: rem(11),
})
